import { SUBSCRIBE_EMAIL_STORAGE_KEY } from './constants';

export const getSubscribeEmail = (): string | undefined => {
	if (typeof window === 'undefined') return undefined;
	try {
		return localStorage.getItem(SUBSCRIBE_EMAIL_STORAGE_KEY) ?? undefined;
	} catch {
		return undefined;
	}
};
